import React, { FC, useEffect, useRef, useState } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { ButtonLink } from '../../ButtonLink';
import { Flex } from '../Flex';
interface Props {
  /** Amount of lines to what content must be truncated */
  lines: number;
  /** We can override default click behaviour and cancel expanding by passing `onReadMoreClick` handler */
  onReadMoreClick?: () => void;
}
const _exp = /*#__PURE__*/() => Flex.Column;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "w1pg4qc",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => ({
  lines
}) => lines ?? '';
const Content = /*#__PURE__*/styled('div')({
  name: "Content",
  class: "ci48o1",
  propsAsIs: false,
  vars: {
    "ci48o1-0": [_exp2()]
  }
});
const FullHeightContent = /*#__PURE__*/styled('div')({
  name: "FullHeightContent",
  class: "fzcohwn",
  propsAsIs: false
});
export const TruncatedContent: FC<Props> = ({
  children,
  lines,
  onReadMoreClick
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const fullHeightContentRef = useRef<HTMLDivElement>(null);
  const handleExpandClick = () => {
    if (onReadMoreClick) {
      onReadMoreClick();
      return;
    }
    setIsExpanded(true);
  };
  useEffect(() => {
    const fullHeightContent = fullHeightContentRef.current;
    const content = contentRef.current;
    if (fullHeightContent && content && fullHeightContent.clientHeight === content.clientHeight) {
      setIsExpanded(true);
    }
  }, []);
  return <Wrapper gap="s300">
      <Content lines={lines} className={cx(isExpanded && 'isExpanded')} ref={contentRef}>
        {children}
      </Content>
      {/* Create invisible absolute positioned block to measure full content height */}
      <FullHeightContent ref={fullHeightContentRef}>
        {children}
      </FullHeightContent>
      {!isExpanded && <ButtonLink size="sm" variant="default" isCompact onClick={handleExpandClick}>
          <FormattedMessageWrapper defaultMessage="Read more" id="readMore" />
        </ButtonLink>}
    </Wrapper>;
};

require("./TruncatedContent.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TruncatedContent.tsx");